import {
	ColorPaletteRoleBackgroundOptions,
	ColorPaletteRoleForegroundOptions,
	ColorPaletteRoleForegroundContrastOptions,
	ColorPaletteRoleForegroundBaseOptions,
} from "../types/theming";

/**
 * Call to resolve an accessible foreground token for the given background color.
 */
export function resolvePaletteRoleForegroundToken(
	backgroundToken: ColorPaletteRoleBackgroundOptions | undefined,
	colorContrast: ColorPaletteRoleForegroundContrastOptions = 1
): ColorPaletteRoleForegroundOptions {
	const withContrast = (
		foregroundToken: ColorPaletteRoleForegroundBaseOptions
	): ColorPaletteRoleForegroundOptions => {
		return `${foregroundToken}_${
			colorContrast || 1
		}` as ColorPaletteRoleForegroundOptions;
	};

	if (backgroundToken) {
		switch (backgroundToken) {
			case "bg_dark":
				return withContrast("fg_light");
			case "bg_dark_variant":
				return withContrast("fg_light");
			case "bg_light":
				return withContrast("fg_dark");
			case "bg_light_variant":
				return withContrast("fg_dark");
			default:
				return withContrast("fg_dark");
		}
	}
	return withContrast("fg_dark");
}
